const React = require('react');
const PropTypes = require('prop-types');
const { BIC_MAX_LENGTH, BIC_REGEX_ALT } = require('constants/index');
const { InputSafe } = require('commonsComponents/inputSafe');

class MaskedBic extends React.Component {

    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.handleBlur = this.handleBlur.bind(this);

        this.state = {
            bic: this.props.bic
        }
    }

    componentWillReceiveProps(nextProps) {
        /*
            Make sure the value was changed by the reducer itself,
            and that was not triggered because a re-render of the parent component.
        */
        if (this.state.bic !== nextProps.bic) {
            this.setState({
                bic: nextProps.bic
            });
        }
    }

    handleBlur(evt) {
        const bic = evt.target.value.toUpperCase();
        const isValid = BIC_REGEX_ALT.test(bic);
        this.props.callback(bic, isValid);
    }

    handleChange(evt) {
        let bic = evt.target.value;
        bic = bic.replace(/[^A-Z\d]/gi, ''); /* remove non numbers or letters */
        this.setState({
            bic
        })
    }

    render () {
        const { errorState, errorMessage, label } = this.props;
        return (
            <InputSafe
                id={this.props.id}
                type="text"
                label={label}
                maxLength={BIC_MAX_LENGTH}
                autoComplete="off"
                value={this.state.bic}
                onChange={this.handleChange}
                onBlur={this.handleBlur}
                errorState={errorState}
                errorMessage={errorMessage}
            />
        );
    }
}

MaskedBic.propTypes = {
    callback: PropTypes.func,
    id: PropTypes.string,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    bic: PropTypes.string,
    errorState: PropTypes.bool,
    errorMessage: PropTypes.string,
    label: PropTypes.string
};

MaskedBic.defaultProps = {
    bic: '',
    label:''
};

module.exports = MaskedBic;
